import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar"; // ✅ Import Navbar
import taxi from "./belfast-cab-tour-cab-tours.png";
import peaceWall from "../assets/images/peace-wall.jpg";
import dunseverickCastle from "../assets/images/dunseverick-castle.jpg";
import "../Styles.css";

const Packages = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollTop(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const tourPackages = [
    {
      name: "Belfast Murals Tour",
      duration: "PT1H30M", // ISO 8601 duration format
      durationText: "1.5 hours",
      price: "70",
      currency: "GBP",
      path: "/cab-tours/murals-tour",
      description: "Explore Belfast murals with our expert black cab guides.",
    },
    {
      name: "Belfast Political Taxi Tour",
      duration: "PT1H30M",
      durationText: "1.5 hours",
      price: "70",
      currency: "GBP",
      path: "/cab-tours/belfast-political",
      description: "Visit Falls Road, Shankill Road, and iconic murals with a knowledgeable guide.",
    },
    {
      name: "Giant’s Causeway and Coastal Tour",
      duration: "PT6H",
      durationText: "6 hours",
      price: "400",
      currency: "GBP",
      path: "/cab-tours/giants-causeway",
      description: "Experience the Giant's Causeway and Antrim Coast on a full-day black cab tour.",
    },
    {
      name: "Dark Hedges and Glens of Antrim Tour",
      duration: "PT5H",
      durationText: "5 hours",
      price: "350",
      currency: "GBP",
      path: "/cab-tours/dark-hedges",
      description: "Visit the Dark Hedges and Glens of Antrim with our experienced local guide.",
    },
  ];

  // JSON-LD structured data using TouristTrip schema
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Belfast & Northern Ireland Taxi Tours",
    "itemListElement": tourPackages.map((tour, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "TouristTrip",
        "name": tour.name,
        "description": tour.description,
        "touristType": "Sightseeing",
        "offers": {
          "@type": "Offer",
          "price": tour.price,
          "priceCurrency": tour.currency,
          "availability": "https://schema.org/InStock",
        },
        "touristMode": "https://schema.org/Taxi",
        "itinerary": {
          "@type": "ItemList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": tour.name,
              "description": tour.description,
            },
          ],
        },
        "duration": tour.duration,
        "url": `https://belfastcabtour.com${tour.path}`,
      },
    })),
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", margin: 0, padding: 0 }}>
      
      <Helmet>
        {/* SEO Meta Tags */}
        <title>Belfast & Northern Ireland Taxi Tours | Black Cab Tours</title>
        <meta
          name="description"
          content="Explore Belfast and Northern Ireland with our pre-planned taxi tours. See murals, historical sites, the Giant's Causeway, and more with expert black cab guides."
        />
        <meta
          name="keywords"
          content="Belfast taxi tours, Northern Ireland black cab tours, Belfast murals tour, Giant's Causeway taxi tour, Dark Hedges tour, Belfast political taxi tour"
        />
        <meta name="author" content="Belfast Cab Tour" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://belfastcabtour.com/cab-tours" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Belfast & Northern Ireland Taxi Tours | Black Cab Tours" />
        <meta property="og:description" content="Explore Belfast and Northern Ireland with our pre-planned taxi tours. See murals, historical sites, the Giant's Causeway, and more with expert black cab guides." />
        <meta property="og:url" content="https://belfastcabtour.com/cab-tours" />
        <meta property="og:image" content="https://belfastcabtour.com/belfast-cab-tour-cab-tours.png" />
        <meta property="og:site_name" content="Belfast Cab Tour" />
        <meta property="og:locale" content="en_GB" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      {/* Navbar */}
      <Navbar />

      {/* Header */}
      <header className="Packages-header" style={{ marginTop: "60px" }}>
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="Belfast & Northern Ireland taxi tours"
            style={{ top: "-2%", transform: `translateY(-${scrollTop / 100}%)` }}
          />
        </div>
      </header>

      {/* Intro Section */}
      <section className="Packages-header1" style={{ textAlign: "center", margin: "40px 20px 20px" }}>
        <h1 style={{ marginBottom: "1em" }}>Belfast & Northern Ireland Taxi Tours</h1>
      
        <div className="tour-image-container">
         <img 
         src={peaceWall}
         alt="cabtours-page"
         className="tour-header-image"
         />
        </div>

        <div className="tour-image-container">
         <img 
         src={dunseverickCastle}
         alt="cabtours-page"
         className="tour-header-image"
         />
        </div>

        <p style={{ marginBottom: "1em", maxWidth: "600px", margin: "0 auto 1em auto" }}>
          The tour cards below are pre-planned packaged taxi tours we offer in Belfast and Northern Ireland, showing the duration and price.
        </p>
        <p style={{ marginBottom: "1em" }}>Click on any of them to find out what is included on the tour.</p>
        <p style={{ marginBottom: "1em" }}>
          Note: personal/bespoke taxi tours can also be arranged via our{" "}
          <Link to="/tour-planning-tool" style={{ color: "#ff6f00", textDecoration: "underline" }}>
            Tour Planner
          </Link>{" "}
          page.
        </p>
      </section>

      {/* Tour Cards Grid */}
      <div className="tour-grid">
        {tourPackages.map((tour, index) => (
          <Link key={index} to={tour.path} className="tour-card">
            <div className="tour-card-inner">
              <h2>{tour.name}</h2>
              <p>{tour.durationText}</p>
              <p className="price">£{tour.price}</p>
            </div>
          </Link>
        ))}
      </div>

      {/* Footer */}
      <footer style={{ textAlign: "center", padding: "1rem", backgroundColor: "#333", color: "#fff", marginTop: "auto" }}>
        &copy; 2025{" "}
        <a href="https://belfastcabtour.com" style={{ color: "#fff", textDecoration: "none" }}>
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default Packages;
